import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);

// PWA: registra o service worker apenas em produção
if (
  import.meta.env.PROD &&
  'serviceWorker' in navigator &&
  import.meta.env.VITE_DISABLE_SW !== 'true'
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.v2.js')
      .then((reg) => {
        // Tenta atualizar imediatamente
        reg.update?.();
      })
      .catch((err) => console.error('SW registration failed:', err));
  });
}

// Garantir que em desenvolvimento não haja SW ativo ou cache antigo
if (!import.meta.env.PROD && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
  if ('caches' in window) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
}
